module.exports = __webpack_public_path__ + "img/Image4@2x.c9e198cb.png";